module.exports = __webpack_public_path__ + "img/comment-alt-message.05bdad7d.svg";